import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.prompts');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-prompts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.prompts/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
  color: #172033;
}

.pm-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #f5f7fb;
  font-size: 13px;
  line-height: 1.55;
}

.pm-shell *, .pm-shell *::before, .pm-shell *::after {
  box-sizing: border-box;
}

.pm-shell h1, .pm-shell h2, .pm-shell h3, .pm-shell h4, .pm-shell p {
  margin: 0;
}

.pm-shell h1 {
  font-size: 20px;
  font-weight: 700;
}

.pm-shell h2 {
  font-size: 17px;
  font-weight: 650;
}

.pm-shell h3 {
  font-size: 15px;
  font-weight: 650;
}

.pm-shell h4 {
  font-size: 13px;
  font-weight: 650;
}

.pm-shell button, .pm-shell input, .pm-shell textarea, .pm-shell select {
  font: inherit;
}

.pm-shell button {
  cursor: pointer;
}

.pm-shell button:disabled {
  cursor: default;
  opacity: 0.5;
}

.pm-shell button:focus-visible, .pm-shell a:focus-visible, .pm-shell input:focus-visible, .pm-shell textarea:focus-visible, .pm-shell select:focus-visible, .pm-shell summary:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 3px;
}

.pm-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 auto;
  gap: 16px;
  padding: 22px 28px 18px;
  border-bottom: 1px solid #e0e6ef;
  background: #fff;
}

.pm-eyebrow {
  color: #567097;
  font-size: 10px;
  letter-spacing: 0.1em;
  font-weight: 700;
}

.pm-header .pm-muted {
  margin-top: 4px;
}

.pm-muted {
  color: #68758a;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.pm-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pm-link {
  color: #365a8a;
  text-decoration: none;
  white-space: nowrap;
}

.pm-button {
  padding: 7px 12px;
  min-height: 34px;
  border: 1px solid #d6dfeb;
  border-radius: 7px;
  color: #314660;
  background: #fff;
  white-space: nowrap;
}

.pm-button:not(:disabled):hover {
  background: #eef4fc;
}

.pm-primary {
  background: #20548d;
  border-color: #20548d;
  color: #fff;
}

.pm-primary:not(:disabled):hover {
  background: #174472;
}

.pm-policy {
  display: flex;
  align-items: baseline;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 6px 12px;
  margin: 16px 24px;
  padding: 11px 14px;
  border: 1px solid #d9e4f3;
  border-radius: 8px;
  background: #eef4fc;
  color: #456082;
  font-size: 12px;
}

.pm-policy strong {
  color: #264d7c;
}

.pm-workspace {
  display: grid;
  grid-template-columns: 286px minmax(0, 1fr);
  flex: 1 1 auto;
  min-height: 0;
  margin: 0 24px 20px;
  border: 1px solid #dce3ee;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.pm-sidebar {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-right: 1px solid #e0e6ef;
  background: #fbfcff;
}

.pm-sidebar-head {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 18px 18px 10px;
}

.pm-sidebar-head h2 {
  font-size: 15px;
}

.pm-count {
  display: inline-block;
  min-width: 22px;
  padding: 1px 6px;
  border-radius: 12px;
  color: #61738e;
  background: #eaf0f7;
  font-size: 11px;
  text-align: center;
}

.pm-filters {
  padding: 0 16px 14px;
}

.pm-filters label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #617089;
  margin: 8px 0 4px;
}

.pm-shell input, .pm-shell select, .pm-shell textarea {
  display: block;
  width: 100%;
  min-width: 0;
  padding: 7px 9px;
  border: 1px solid #cfd9e6;
  border-radius: 6px;
  background: #fff;
  color: #172033;
}

.pm-shell textarea {
  resize: vertical;
  line-height: 1.65;
}

.pm-shell input::placeholder, .pm-shell textarea::placeholder {
  color: #94a0b2;
}

.pm-edit-note {
  padding: 0 16px 12px;
  color: #72613d;
  font-size: 11px;
}

.pm-prompt-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 0 10px 12px;
}

.pm-prompt {
  display: block;
  width: 100%;
  margin-bottom: 6px;
  padding: 11px 10px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: inherit;
  text-align: left;
}

.pm-prompt:not(:disabled):hover, .pm-version:not(:disabled):hover {
  background: #f0f5fc;
}

.pm-prompt.is-selected {
  border-color: #bfd3ef;
  background: #eaf2ff;
}

.pm-prompt:disabled, .pm-version:disabled {
  opacity: 0.75;
}

.pm-prompt-function {
  display: block;
  margin-bottom: 3px;
  color: #5e7393;
  font-size: 10px;
}

.pm-prompt strong {
  display: block;
  font-size: 13px;
  font-weight: 650;
}

.pm-prompt code {
  display: block;
  margin-top: 3px;
  color: #77839a;
  font-size: 10px;
  overflow-wrap: anywhere;
}

.pm-prompt-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  color: #758198;
  font-size: 10px;
}

.pm-badge {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 5px;
  background: #eef1f6;
  color: #5c6980;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}

.pm-badge.is-test {
  background: #e6f0ff;
  color: #315d98;
}

.pm-main {
  min-height: 0;
  min-width: 0;
  overflow: auto;
  padding: 22px 24px;
}

.pm-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 18px;
}

.pm-detail-header .pm-muted {
  margin-top: 5px;
}

.pm-id {
  display: inline-block;
  margin-top: 8px;
  color: #7a879c;
  font-size: 11px;
  overflow-wrap: anywhere;
}

.pm-rule-note {
  padding: 10px 13px;
  margin: 0 0 16px;
  border: 1px solid #e7dfca;
  border-radius: 7px;
  color: #776136;
  background: #fffaf0;
  font-size: 12px;
}

.pm-rule-note p {
  margin-top: 3px;
}

.pm-message {
  padding: 10px 12px;
  border: 1px solid;
  border-radius: 7px;
  overflow-wrap: anywhere;
}

.pm-shell > .pm-message {
  margin: 0 24px 16px;
}

.pm-message small {
  display: block;
  margin-top: 5px;
}

.pm-message .pm-button {
  margin-top: 9px;
}

.pm-error {
  margin-bottom: 14px;
  border-color: #edc7c5;
  color: #9c3c36;
  background: #fff7f6;
}

.pm-notice {
  margin-bottom: 16px;
  border-color: #c7dfd6;
  color: #346d59;
  background: #f1faf6;
}

.pm-version-layout {
  display: grid;
  grid-template-columns: 154px minmax(0, 1fr);
  gap: 24px;
}

.pm-version-nav {
  min-width: 0;
}

.pm-version-nav h3 {
  margin-bottom: 10px;
  font-size: 12px;
  color: #65758d;
}

.pm-version {
  display: block;
  width: 100%;
  padding: 10px 9px;
  margin-bottom: 6px;
  text-align: left;
  border: 1px solid #e0e6ee;
  border-radius: 7px;
  background: #fff;
  color: #4b5c73;
}

.pm-version.is-selected {
  border-color: #9fbce1;
  background: #f1f6ff;
}

.pm-version > span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.pm-version strong {
  font-weight: 650;
  color: #2c4a70;
}

.pm-version small {
  display: block;
  margin-top: 4px;
  color: #7c889b;
  font-size: 10px;
  overflow-wrap: anywhere;
}

.pm-version-body {
  min-width: 0;
}

.pm-section-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.pm-section-heading h3, .pm-section-heading h4 {
  margin-right: auto;
}

.pm-readonly-label {
  color: #8a96a8;
  font-size: 10px;
}

.pm-meta, .pm-model-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 22px;
  margin: 0;
}

.pm-meta {
  padding-bottom: 20px;
  border-bottom: 1px solid #edf0f5;
}

.pm-meta-wide {
  grid-column: 1/-1;
}

.pm-shell dt {
  margin-bottom: 3px;
  color: #7b879a;
  font-size: 11px;
}

.pm-shell dd {
  margin: 0;
  color: #3f5068;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.pm-section {
  margin-top: 21px;
}

.pm-section > h4 {
  margin-bottom: 9px;
}

.pm-prompt-content {
  margin: 0;
  padding: 14px 16px;
  max-height: 410px;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  border: 1px solid #e0e6ee;
  border-radius: 7px;
  background: #f8faff;
  color: #334861;
  font: 12px/1.8 ui-monospace, SFMono-Regular, Consolas, monospace;
}

.pm-small-pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  padding: 10px;
  border-radius: 6px;
  background: #f7f9fc;
  color: #617089;
  font-size: 11px;
}

.pm-preserve {
  margin-top: 8px !important;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.pm-integrity {
  margin-top: 20px;
  color: #8a96a8;
  font-size: 10px;
}

.pm-integrity summary {
  cursor: pointer;
}

.pm-integrity code {
  display: block;
  margin-top: 6px;
  overflow-wrap: anywhere;
}

.pm-editor > .pm-muted {
  margin: -5px 0 16px;
}

.pm-editor fieldset {
  padding: 0;
  border: 0;
  min-width: 0;
  margin: 0;
}

.pm-editor h4 {
  margin: 18px 0 5px;
}

.pm-field {
  margin-top: 12px;
}

.pm-field label {
  display: block;
  margin-bottom: 5px;
  color: #56657c;
  font-size: 12px;
  font-weight: 550;
}

.pm-content-input {
  font-family: ui-monospace, SFMono-Regular, Consolas, monospace !important;
  font-size: 12px !important;
  min-height: 220px;
}

.pm-model-fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 10px;
}

.pm-model-id {
  grid-column: 1/-1;
}

.pm-evaluation-editor {
  margin-top: 20px;
  padding: 0 14px 14px;
  border: 1px solid #e0e6ef;
  border-radius: 7px;
  background: #fafcff;
}

.pm-editor-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.pm-editor .pm-error {
  margin-top: 14px;
}

.pm-empty {
  padding: 30px 16px;
  color: #8a96a8;
  text-align: center;
  font-size: 12px;
}

.pm-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (min-width: 1500px) {
  .pm-shell {
    padding-right: max(0px, (100vw - 1600px) / 2);
    padding-left: max(0px, (100vw - 1600px) / 2);
  }
}
@media (max-width: 1050px) {
  .pm-workspace {
    grid-template-columns: 240px minmax(0, 1fr);
  }
  .pm-main {
    padding: 18px;
  }
  .pm-version-layout {
    grid-template-columns: 124px minmax(0, 1fr);
    gap: 16px;
  }
  .pm-detail-header {
    flex-wrap: wrap;
    gap: 12px;
  }
}
@media (max-width: 760px) {
  .pm-shell {
    height: auto;
    min-height: 100%;
  }
  .pm-header {
    padding: 18px 16px;
    align-items: flex-start;
  }
  .pm-header-actions {
    flex-direction: column;
    gap: 9px;
    align-items: flex-end;
  }
  .pm-policy {
    margin: 12px;
  }
  .pm-workspace {
    display: block;
    flex: none;
    margin: 0 12px 16px;
  }
  .pm-sidebar {
    border-right: 0;
    border-bottom: 1px solid #e0e6ef;
  }
  .pm-prompt-list {
    max-height: 260px;
  }
  .pm-main {
    overflow: visible;
    padding: 18px 14px;
  }
  .pm-version-layout {
    grid-template-columns: minmax(0, 1fr);
    gap: 18px;
  }
  .pm-version-nav {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    overflow: auto;
    padding: 0 0 7px;
  }
  .pm-version-nav h3 {
    flex: 0 0 54px;
    padding-top: 10px;
  }
  .pm-version {
    flex: 0 0 135px;
  }
  .pm-model-summary, .pm-meta {
    gap: 12px;
  }
  .pm-shell > .pm-message {
    margin: 0 12px 16px;
  }
}`],
})
export class PageAdminPromptsComponent implements OnInit, OnDestroy {
    public prompts: any[] = [];
    public detail: any = null;
    public selectedVersion: any = null;
    public search = '';
    public functionFilter = '';
    public loading = true;
    public detailLoading = false;
    public saving = false;
    public error = '';
    public detailError = '';
    public saveError = '';
    public notice = '';
    public editing = false;
    public conflict = false;
    public editor: any = {};
    private requestId = 0;
    private destroyed = false;

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        try {
            await this.service.init();
            await this.load();
        } catch (error) {
            this.error = '인증 정보를 확인하지 못했습니다. 잠시 후 다시 시도해 주세요.';
            this.loading = false;
            await this.render();
        }
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.requestId++;
    }

    private async render() {
        if (!this.destroyed) await this.service.render();
    }

    public get functions(): string[] {
        return Array.from(new Set(this.prompts.map(item => String(item.function || 'additional'))));
    }

    public get filteredPrompts(): any[] {
        const query = this.search.trim().toLocaleLowerCase();
        return this.prompts.filter(item => (!this.functionFilter || item.function === this.functionFilter)
            && (!query || [item.name, item.promptId, item.function, item.description, this.functionLabel(item.function)]
                .some(value => String(value || '').toLocaleLowerCase().includes(query))));
    }

    public functionLabel(value: string): string {
        const labels: any = {
            "system": "공통 시스템 프롬프트",
            "query-analysis": "질의 분석",
            "search-query": "검색 질의 생성",
            "rag-answer": "RAG·일반 답변 생성",
            "response-format": "응답 JSON 형식",
            "answer-validation": "답변 검증 후 교정 재작성",
            "data-answer": "데이터 조회 답변 생성",
            "data-review": "반환 데이터 배치 검토",
            "conversation-response": "일반 대화·상태 안내",
            "page-guidance": "메인 페이지 안내",
            "wafer-answer": "웨이퍼 결함 결과 해석",
            "prediction-answer": "예측 결과 해석",
            "prediction-notice": "AI 모델 작업 상태 안내",
            "report-type": "보고서 유형 분류",
            "report-answer": "보고서 구조화 초안",
            "document-classification": "문서 통제 카테고리 분류",
            "document-metadata": "문서 코퍼스 메타데이터 생성",
            query_analysis: '질의 분석', search_query: '검색 질의 생성',
            search_query_generation: '검색 질의 생성', rag_answer: 'RAG 답변 생성',
            rag_answer_generation: 'RAG 답변 생성', answer_validation: '답변 검증',
            response_format: '응답 형식', additional: '부가 기능'
        };
        return labels[value] || value || '부가 기능';
    }

    public statusLabel(value: string): string {
        return ({draft: '초안', test: '테스트', production: '운영', archived: '보관'} as any)[value] || value || '—';
    }

    public evaluationLabel(value: string): string {
        return ({not_run: '미실행', passed: '통과 (기록)', failed: '실패 (기록)'} as any)[value] || '미실행';
    }

    public formatDate(value: string): string {
        if (!value) return '—';
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? value : date.toLocaleString('ko-KR');
    }

    public display(value: any): string {
        if (value === undefined || value === null || value === '') return '미설정';
        return typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value);
    }

    private message(response: any, fallback: string): string {
        if (Number(response?.code) === 401) return '인증된 관리자 계정으로 접근한 뒤 다시 시도해 주세요.';
        if (Number(response?.code) === 403) return '프롬프트 관리 권한이 없습니다. 서버의 config/prompt-management.json에 관리자로 등록되어야 합니다.';
        return response?.data?.message || response?.message || fallback;
    }

    public async filterChanged() {
        await this.render();
    }

    public async load() {
        if (this.editing || this.saving) return;
        this.loading = true;
        this.error = '';
        await this.render();
        try {
            const response = await wiz.call('overview');
            if (this.destroyed) return;
            if (Number(response?.code) !== 200) {
                this.prompts = [];
                this.detail = null;
                this.selectedVersion = null;
                this.error = this.message(response, '프롬프트 목록을 불러오지 못했습니다.');
                return;
            }
            this.prompts = response.data?.prompts || [];
            const selectedId = this.detail?.promptId;
            const first = this.prompts.find(item => item.promptId === selectedId) || this.prompts[0];
            if (first) await this.selectPrompt(first.promptId);
            else {
                this.detail = null;
                this.selectedVersion = null;
            }
        } catch (error) {
            this.error = '서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.';
        } finally {
            this.loading = false;
            await this.render();
        }
    }

    public async selectPrompt(promptId: string, preserveEditor = false) {
        if (this.saving || (this.editing && !preserveEditor)) return;
        const requestId = ++this.requestId;
        this.detailLoading = true;
        this.detailError = '';
        if (!preserveEditor) {
            this.detail = null;
            this.selectedVersion = null;
            this.notice = '';
        }
        await this.render();
        try {
            const response = await wiz.call('detail', {prompt_id: promptId});
            if (this.destroyed || requestId !== this.requestId) return;
            if (Number(response?.code) !== 200) {
                this.detailError = this.message(response, '프롬프트 상세 정보를 불러오지 못했습니다.');
                return;
            }
            this.detail = response.data;
            const versions = this.detail?.versions || [];
            if (!preserveEditor) {
                this.selectedVersion = versions.find(item => item.version === this.detail.latestVersion) || versions[0] || null;
            } else {
                this.editor.baseVersion = this.detail.latestVersion;
                this.conflict = false;
                this.saveError = '';
                this.notice = '최신 버전 v' + this.detail.latestVersion + '을 확인했습니다. 편집 내용은 유지되므로 검토 후 다시 저장하세요.';
            }
        } catch (error) {
            if (requestId === this.requestId) this.detailError = '상세 정보를 불러오는 중 연결이 끊겼습니다.';
        } finally {
            if (requestId === this.requestId) {
                this.detailLoading = false;
                await this.render();
            }
        }
    }

    public async selectVersion(version: any) {
        if (this.editing || this.saving) return;
        this.selectedVersion = version;
        this.notice = '';
        await this.render();
    }

    public async startVersion() {
        if (!this.selectedVersion || this.detailLoading) return;
        const version = this.selectedVersion;
        this.editor = {
            baseVersion: this.detail.latestVersion,
            sourceVersion: version.version,
            content: version.content || '',
            modelId: version.modelConfig?.modelId ?? '',
            temperature: version.modelConfig?.temperature ?? '',
            top_p: version.modelConfig?.top_p ?? '',
            max_tokens: version.modelConfig?.max_tokens ?? '',
            changeReason: '',
            status: 'draft',
            evaluationStatus: 'not_run',
            evaluationSummary: ''
        };
        this.editing = true;
        this.conflict = false;
        this.saveError = '';
        this.notice = '';
        await this.render();
    }

    public async cancelVersion() {
        if (this.saving) return;
        this.editing = false;
        this.conflict = false;
        this.saveError = '';
        this.notice = '';
        await this.render();
    }

    public async refreshLatest() {
        if (!this.detail?.promptId || this.saving) return;
        await this.selectPrompt(this.detail.promptId, true);
    }

    private optionalNumber(value: any): number | null {
        return value === '' || value === null || value === undefined ? null : Number(value);
    }

    public async createVersion() {
        if (this.saving || this.conflict || this.detailLoading || !this.detail) return;
        this.saveError = '';
        if (!String(this.editor.content || '').trim() || !String(this.editor.changeReason || '').trim()) {
            this.saveError = '프롬프트 내용과 변경 사유를 입력해 주세요.';
            await this.render();
            return;
        }
        const temperature = this.optionalNumber(this.editor.temperature);
        const topP = this.optionalNumber(this.editor.top_p);
        const maxTokens = this.optionalNumber(this.editor.max_tokens);
        if ((temperature !== null && (!Number.isFinite(temperature) || temperature < 0 || temperature > 2))
            || (topP !== null && (!Number.isFinite(topP) || topP < 0 || topP > 1))
            || (maxTokens !== null && (!Number.isInteger(maxTokens) || maxTokens <= 0))) {
            this.saveError = 'temperature는 0~2, top_p는 0~1, max_tokens는 양의 정수로 입력해 주세요.';
            await this.render();
            return;
        }
        const csrf = this.service.auth.session?.chat_csrf;
        if (!csrf) {
            this.saveError = '로그인 세션을 확인하지 못했습니다. 편집 내용을 보관한 뒤 다시 로그인해 주세요.';
            await this.render();
            return;
        }
        const payload = {
            baseVersion: this.editor.baseVersion,
            content: this.editor.content,
            modelConfig: {modelId: String(this.editor.modelId || '').trim() || null, temperature, top_p: topP, max_tokens: maxTokens},
            changeReason: this.editor.changeReason.trim(),
            status: this.editor.status,
            evaluation: {status: this.editor.evaluationStatus, summary: String(this.editor.evaluationSummary || '').trim()}
        };
        this.saving = true;
        await this.render();
        try {
            const response = await wiz.call('create_version', {
                prompt_id: this.detail.promptId, payload: JSON.stringify(payload), chat_csrf_token: csrf
            });
            if (this.destroyed) return;
            if (Number(response?.code) !== 200) {
                this.conflict = Number(response?.code) === 409;
                this.saveError = this.conflict
                    ? '다른 사용자가 새 버전을 생성했습니다. 입력은 유지됩니다. 최신 버전을 불러온 뒤 검토해 주세요.'
                    : this.message(response, '새 버전을 저장하지 못했습니다.');
                return;
            }
            const version = response.data;
            this.detail.versions = [version, ...(this.detail.versions || [])];
            this.detail.latestVersion = version.version;
            this.selectedVersion = version;
            this.prompts = this.prompts.map(item => item.promptId === this.detail.promptId
                ? {...item, latestVersion: version.version, status: version.status, versionCount: this.detail.versions.length} : item);
            this.editing = false;
            this.notice = 'v' + version.version + '을 ' + this.statusLabel(version.status) + ' 상태로 기록했습니다. 운영에는 적용되지 않습니다.';
        } catch (error) {
            this.saveError = '저장 중 연결이 끊겼습니다. 입력은 유지됩니다. 최신 버전을 확인한 뒤 다시 시도해 주세요.';
            this.conflict = true;
        } finally {
            this.saving = false;
            await this.render();
        }
    }
}

export default PageAdminPromptsComponent;